import React from "react";
import { Tabs, Tab } from "@mui/material";
import { TabPanel, TabContext } from "@mui/lab";
import GroupsByRound from "./GroupsByRound";
import GroupsByPerson from "./GroupsByPerson";
import { EventContext } from "../../../contexts/EventContext";

import request from "../../../utilities/requests";

const GroupResults = () => {
  const { pairingEvent, groups, setGroups, setMissingRounds } = React.useContext(EventContext);
  const [value, setValue] = React.useState("1");
  const [byPerson, setByPerson] = React.useState([]);

  React.useEffect(() => {
    if (pairingEvent) {
      getGroups();
    }
  }, [pairingEvent]);

  const getGroups = async () => {
    const result = await request(
      `pairingevent/groups?pairingEventId=${pairingEvent._id}`
    );
    if (!result.success) {
      alert(result.error);
      return;
    }
    setGroups(result.groups);
    setByPerson(result.byUser);
    if (result.missingRounds) {
      setMissingRounds(result.missingRounds);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <TabContext value={value}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="By Round" value="1" />
          <Tab label="By Person" value="2" />
        </Tabs>
        <TabPanel value="1" index={0}>
          <GroupsByRound groups={groups} refresh={getGroups} />
        </TabPanel>
        <TabPanel value="2" index={1}>
          <GroupsByPerson byPerson={byPerson}  />
        </TabPanel>
      </TabContext>
    </div>
  );
};

export default GroupResults;
